var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 35,
    viewBox: "0 0 35 35",
    width: 35,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    fill: "none",
    r: 16.75
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m-375.225 0a4.309 4.309 0 0 1 3.237 1.329 9.083 9.083 0 0 0 2.78-1.029 3.775 3.775 0 0 1 -1.781 2.448c-.015 0 .654-.143 2.361-.71a4.9 4.9 0 0 1 -2.212 2.266c0 .285.012 1.859 0 1.847.213 4.472-7.175 15.937-19.094 9.313-.728 0 4.2.346 6.293-1.879a4.2 4.2 0 0 1 -3.96-2.99c.3-.008 1.742.094 1.872-.1-.026.008-3.544-.842-3.38-4.34.044-.021 1.873.767 1.924.492-.12.372-3.328-2.592-1.257-5.86 3.025 4.081 9.051 4.9 8.973 4.611a4.231 4.231 0 0 1 -.142-1.091 4.346 4.346 0 0 1 4.386-4.307z",
    fill: "#fff",
    transform: "translate(396.962 8.726)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwitter);
export default __webpack_public_path__ + "static/media/icon-twitter.f4fb04096f0bfa90a0a95f782c1046d8.svg";
export { ForwardRef as ReactComponent };